import { render, staticRenderFns } from "./BusClsReview.vue?vue&type=template&id=234c04e0&"
import script from "./BusClsReview.vue?vue&type=script&lang=js&"
export * from "./BusClsReview.vue?vue&type=script&lang=js&"
import style0 from "./BusClsReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BusClsReview.vue"
export default component.exports